import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import TableBasic from '../../../atoms/table-basic';
import format from '../../../../utils/format';
import styles from './interest-crediting-rates.module.scss';
import useInterestCreditingRates from '../../../../stores/profile/modules/use-interest-crediting-rates';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import PropTypes from 'prop-types';

const className = augmentClassName(styles);

const InterestCreditingRates = ({ isTIAAQdia }) => {
  const { asOfDate, dateTo, descriptionText, tableData } = useInterestCreditingRates({
    isTIAAQdia
  });
  return (
    <CardModule
      data-analytics-componenttype="full-width-component"
      data-analytics-id="FW_InterestCreditingRates"
      data-analytics-section="component"
    >
      <CardModule.Header>Interest Crediting Rates</CardModule.Header>
      <CardModule.Body>
        <Row>
          <Col md={4}>
            <p {...className('paragraph-emphasized')}>{descriptionText.headline}</p>
            <p {...className('paragraph-standard')}>{descriptionText.body}</p>
            <p {...className('paragraph-standard', 'font-italic')}>{descriptionText.emphasis}</p>
          </Col>
          <Col md={8}>
            <TableBasic {...className('table')}>
              <caption {...className('caption')}>
                <h5>
                  Total effective interest rates credited on{' '}
                  {isTIAAQdia ? 'TIAA Secure Income Account' : 'TIAA Traditional Annuity'}{' '}
                  accumulations
                  <span {...className('as-of-date', 'from-to-label')}>
                    {`(As of ${format.date(asOfDate)}) - guaranteed through ${format.date(dateTo)}`}
                  </span>
                </h5>
              </caption>
              <thead>
                <tr>
                  <th scope="col" {...className('text-left', 'w-15')}>
                    Contributions Applied
                  </th>
                  <th scope="col">Interest Rate</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => {
                  if (row.rate > 0) {
                    return (
                      <tr
                        data-key={`${row.label || ''}-${index}`}
                        key={`${row.label || ''}-${index}`}
                      >
                        <td>{row.label}</td>
                        <td>{format.percent(row.rate)}</td>
                      </tr>
                    );
                  }
                  return null;
                })}
              </tbody>
            </TableBasic>
          </Col>
        </Row>
      </CardModule.Body>
      <CardModule.Footer {...className('text-right')}>
        <ButtonDisclosures module={'interest-crediting-rates'} />
      </CardModule.Footer>
    </CardModule>
  );
};

InterestCreditingRates.propTypes = {
  isTIAAQdia: PropTypes.bool
};

export default InterestCreditingRates;
